// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__NCY3McDO","tab":"Tabs_tab__WEec7c8a","active":"Tabs_active__m-RF87kz"};